import React, { useEffect } from "react";

const GaleriaCard = (props) => {


  const cards =  props.users.map((user, index)  => 
    <div className="galeriaCard__main offset-col-2 col-8  col-md-3 my-5 my-md-3 mx-2 mx-sm-4" key={index}>
      {/* <div className="containerTelon">
        <div className="telon"></div>
      </div> */}
      <img
        alt="gallery"
        className="galeriaCard__photo"
        height="120"
        width="120"
        src={user.picture}
      />
      <div className="galeriaCard__content">
        <h3 className="galeriaCard__title pt-3 pb-3">{user.name}</h3>
        <span>{user.state}</span>
        <p className="galeriaCard__text overflow-hidden">
          {user.history}
        </p>
        <a type="button" data-toggle="modal" data-target={"#modalGallery" + index} className="galeriaCard__link" href="javascript(void)">Leer más</a>

        <div className="modal fade" id={"modalGallery" + index} role="dialog" aria-labelledby="modalGalleryLabel" aria-hidden="true">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title" id="modalGalleryLabel">Historia</h4>
                <button type="button" className="close" data-dismiss="modal" aria-label="Cerrar">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
              <p className="galeriaCard__text">
                {user.history}
              </p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-dismiss="modal">Cerrar Historia</button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  )

  return (
    <div class="row justify-content-center w-100 mx-auto">
    {cards}
    </div>
  );
};

export default GaleriaCard;
